(function () {
    var typed = '';
    var TRIGGER = 'friend';

    document.addEventListener('keypress', function (e) {
        typed += e.key.toLowerCase();
        if (typed.length > TRIGGER.length) typed = typed.slice(-TRIGGER.length);
        if (typed === TRIGGER) { typed = ''; spawnFriend(); }
    });

    if (decodeURIComponent(window.location.pathname).includes('/bücher/20th-century-boys')) {
        setTimeout(spawnFriend, 700);
    }

    function spawnFriend() {
        if (document.querySelector('.friend-overlay')) return;

        var overlay = document.createElement('div');
        overlay.className = 'friend-overlay';

        var mask = document.createElement('div');
        mask.className = 'friend-mask';
        mask.innerHTML = '<svg viewBox="0 0 220 270" width="220" height="270" xmlns="http://www.w3.org/2000/svg">'
            // Mask body — plain oval, off-white
            + '<ellipse cx="110" cy="148" rx="98" ry="118" fill="#eee8de"/>'
            // Subtle cheek contour
            + '<ellipse cx="72" cy="168" rx="28" ry="18" fill="rgba(0,0,0,0.04)"/>'
            + '<ellipse cx="148" cy="168" rx="28" ry="18" fill="rgba(0,0,0,0.04)"/>'
            // Eye holes — almond shaped, dark
            + '<ellipse cx="76" cy="132" rx="18" ry="13" fill="#141414"/>'
            + '<ellipse cx="144" cy="132" rx="18" ry="13" fill="#141414"/>'
            // Very faint inner eye glow
            + '<ellipse cx="76" cy="132" rx="8" ry="6" fill="rgba(30,20,10,0.5)"/>'
            + '<ellipse cx="144" cy="132" rx="8" ry="6" fill="rgba(30,20,10,0.5)"/>'
            + '</svg>';

        var caption = document.createElement('div');
        caption.className = 'friend-caption';
        caption.textContent = 'ともだち…';

        overlay.appendChild(mask);
        overlay.appendChild(caption);

        var closeBtn = document.createElement('button');
        closeBtn.className = 'ee-close';
        closeBtn.textContent = '×';
        closeBtn.addEventListener('click', function () {
            overlay.classList.add('friend-overlay--fade');
            setTimeout(function () { overlay.remove(); }, 1200);
        });
        overlay.appendChild(closeBtn);
        document.body.appendChild(overlay);

        setTimeout(function () {
            overlay.classList.add('friend-overlay--fade');
            setTimeout(function () { overlay.remove(); }, 1200);
        }, 4000);
    }
})();
